/**
 * Created by olga on 31.01.2025
 */

const HeroesTutorial = function () {
    return new TutorialScenario("heroes", {
        listSteps: HeroesTutorial.listSteps,
        isAvailable: function () {
            return cleverapps.environment.isHeroesScene()
                && (HeroesTutorial.getUnlockHero() || HeroesTutorial.getUpgradeHero());
        }
    });
};

HeroesTutorial.listSteps = function () {
    const steps = [];
    const toUnlock = HeroesTutorial.getUnlockHero();

    if (toUnlock) {
        steps.push(...HeroesTutorial.createSteps(toUnlock, {
            text: "Forces.UnlockHero"
        }));
    }

    const toUpgrade = HeroesTutorial.getUpgradeHero();
    if (toUpgrade) {
        steps.push(...HeroesTutorial.createSteps(toUpgrade, {
            text: "Forces.UpgradeFirstHero"
        }));
    }

    return steps.map((step) => new TutorialStep(step));
};

HeroesTutorial.createSteps = function (color, force) {
    return [{
        onStart: function () {
            const heroBuildings = cleverapps.Scenes.GetSceneComponent(HeroesSceneComponent).heroBuildings;

            this.force = cleverapps.forces.create(heroBuildings[color].button, force, {
                highlights: [heroBuildings[color]]
            });

            cleverapps.eventBus.on("window_shown", this.finish.bind(this), this);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    }, {
        onStart: function () {
            const heroWindow = cleverapps.focusManager.currentWindow();
            
            this.force = cleverapps.forces.create(heroWindow.buttons, {}, {
                highlights: [heroWindow]
            });

            cleverapps.eventBus.on("closeWindows", this.finish.bind(this), this);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    }];
};

HeroesTutorial.getUnlockHero = function () {
    const color = HeroesTutorial.UNLOCK_HERO;
    if (match3.heroes.getLevel(color) === 0 && match3.heroes.isHeroAvailable(color)) {
        return color;
    }
};

HeroesTutorial.getUpgradeHero = function () {
    const color = HeroesTutorial.UPGRADE_HERO;
    if (match3.heroes.getLevel(color) === 1 && match3.heroes.isHeroAvailable(color)) {
        return color;
    }
};

HeroesTutorial.UPGRADE_HERO = "e";
HeroesTutorial.UNLOCK_HERO = "w";
